import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button, Col, Container, Field, Heading, Row, PageContent, Select } from 'components';
import { Margin } from 'styled-components-spacing';
import { useMemo } from 'react';
import { useEffect } from 'react';
import { getSignatureOptions } from '../../../../api/services/cis';
import { toApiDate } from 'helpers/date';

function RenewCertificate({
  state,
  dispatch,
  updateFieldCreator,
  renewCertificate,
  type,
  levelDomains,
}) {
  const { t } = useTranslation();
  const history = useHistory();

  const handleChangeField = (name) => (e) => {
    dispatch(updateFieldCreator({ name, value: e.target.value }));
  };

  const handleChangeSelect = (name) => (option) => {
    dispatch(updateFieldCreator({ name, value: option?.value }));
  };

  const levelDomainOptions = useMemo(() => {
    return levelDomains.filter((ld) => ld.level === state.levelDomain?.level?.id);
  }, [levelDomains, state.levelDomain]);

  console.log(state);

  useEffect(() => {
    if (state.memberAssociation) {
      getSignatureOptions({
        memberAssociation: state.memberAssociation,
      }).then((signatureOptions) => {
        signatureOptions.json().then((res) => {
          const options = res.results.result.map((item) => ({
            label: item.user?.firstName + ' ' + item.user?.lastName,
            value: item.id,
            assessorType: item?.assessorType,
          }));
          dispatch(updateFieldCreator({ name: 'signatureOptions', value: options }));
        });
      });
    }
  }, [state.memberAssociation, dispatch]);

  const submit = () => {
    const payload = {
      certificateHolder: state.certificateHolder,
      certificateLevelDomain: state.certificateLevelDomain,
      issueDate: toApiDate(state.issueDate),
      validUntil: toApiDate(state.validUntil),
      type: state.type,
      certId: state.certId,
      holderAuthorized: state.holderAuthorized ? 1 : 0,
      visibility: state.visibility ? 1 : 0,
      organization: state.organization,
      assessorSignature: state.assessorSignature,
      headSignature: state.headSignature,
    };

    if (type !== 'ma') {
      payload.certificationBody = state.certificationBody;
    }

    renewCertificate(payload, history);
  };

  return (
    <PageContent>
      <Container>
        <form>
          <Margin bottom="24">
            <Heading size="h5">{t('page.user.cis.certificates.renewCertificate')}</Heading>
          </Margin>
          <Margin bottom="24">
            <Heading size="h6">
              {t('page.user.cis.certificates.chooseToUpdateCertificateNumber')}
            </Heading>
          </Margin>
          <Row>
            <Col size={{ xl: 1 / 3 }}>
              <Margin bottom="20">
                <Field
                  id="certId"
                  label={t('page.user.cis.certificates.certificateNumber')}
                  required
                >
                  <input
                    id="certId"
                    type="text"
                    placeholder={t('page.user.cis.certificates.certificateNumberPlaceholder')}
                    value={state.certId}
                    onChange={handleChangeField('certId')}
                  />
                </Field>
              </Margin>
            </Col>
            <Col size={{ xl: 1 / 3 }}>
              <Margin bottom="20">
                <Field
                  id="certificateLevelDomain"
                  label={t('page.user.cis.certificates.levelDomain')}
                  value={
                    levelDomainOptions.find(
                      (option) => option.value === state.certificateLevelDomain,
                    ) || ''
                  }
                  clear={() => handleChangeSelect('certificateLevelDomain')(null)}
                  required
                  disabled={
                    state.levelDomain?.level?.name !== 'A' && state.levelDomain?.level?.name !== 'B'
                  }
                >
                  <Select
                    id="certificateLevelDomain"
                    type="text"
                    placeholder={t('page.user.cis.certificates.levelDomainPlaceholder')}
                    value={
                      levelDomainOptions.find(
                        (option) => option.value === state.certificateLevelDomain,
                      ) || ''
                    }
                    options={levelDomainOptions}
                    disabled={
                      state.levelDomain?.level?.name !== 'A' &&
                      state.levelDomain?.level?.name !== 'B'
                    }
                    onChange={handleChangeSelect(
                      'certificateLevelDomain',
                      'certificateLevelDomain',
                    )}
                  />
                </Field>
              </Margin>
            </Col>
            <Col size={{ xl: 1 / 3 }}>
              <Margin bottom="20">
                <Field
                  required={type === 'ma'}
                  id="headSignature"
                  label={t('page.user.cis.certificates.headSignature')}
                  value={
                    state.signatureOptions.find((option) => option.value === state.headSignature) ||
                    ''
                  }
                  clear={() => handleChangeSelect('headSignature')(null)}
                >
                  <Select
                    id="headSignature"
                    name="headSignature"
                    placeholder={t('page.user.cis.certificates.selectSignaturePlaceholder')}
                    options={state.signatureOptions.filter(
                      (option) =>
                        option.value !== state.assessorSignature && option.assessorType === 'H',
                    )}
                    disabled={
                      state.signatureOptions?.length === 0 || state.memberAssociation === null
                    }
                    value={
                      state.signatureOptions.find((option) => option.value === state.headSignature) ||
                      ''
                    }
                    onChange={handleChangeSelect('headSignature', 'headSignature')}
                  />
                </Field>
              </Margin>
            </Col>
          </Row>
          <Row>
            <Col size={{ xl: 1 / 3 }}>
              <Margin bottom="20">
                <Field
                  required={type === 'ma'}
                  id="assessorSignature"
                  label={t('page.user.cis.certificates.assessorSignature')}
                  value={
                    state.signatureOptions.find((option) => option.value === state.assessorSignature) ||
                    ''
                  }
                  clear={() => handleChangeSelect('assessorSignature')(null)}
                >
                  <Select
                    id="assessorSignature"
                    name="assessorSignature"
                    placeholder={t('page.user.cis.certificates.selectSignaturePlaceholder')}
                    options={state.signatureOptions.filter(
                      (option) =>
                        option.value !== state.headSignature && option.assessorType === 'S',
                    )}
                    disabled={
                      state.signatureOptions?.length === 0 || state.memberAssociation === null
                    }
                    value={
                      state.signatureOptions.find(
                        (option) => option.value === state.assessorSignature,
                      ) || ''
                    }
                    onChange={handleChangeSelect('assessorSignature', 'assessorSignature')}
                  />
                </Field>
              </Margin>
            </Col>
          </Row>
          <Row>
            <Col size={{ xl: 1 / 3 }}>
              <Margin bottom={{ xs: 12, md: 0 }}>
                <Button type="button" onClick={() => submit()}>
                  {t('global.confirmButton')}
                </Button>
              </Margin>
            </Col>
          </Row>
        </form>
      </Container>
    </PageContent>
  );
}

RenewCertificate.propTypes = {
  state: PropTypes.shape({
    id: PropTypes.number,
    certificateHolder: PropTypes.number,
    levelDomain: PropTypes.number,
    certificationBody: PropTypes.number,
    issueDate: PropTypes.any,
    type: PropTypes.string,
    validUntil: PropTypes.any,
    certId: PropTypes.string,
    holderAuthorized: PropTypes.bool,
    visibility: PropTypes.bool,
    organization: PropTypes.number,
  }),
  dispatch: PropTypes.func.isRequired,
  updateFieldCreator: PropTypes.func.isRequired,
  renewCertificate: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['ipma', 'ma']),
};

RenewCertificate.defaultProps = {
  state: {},
  type: 'ipma',
};

export default RenewCertificate;
